import { createSelector } from '@reduxjs/toolkit';
import { selectors as calendarSelectors } from '../Modules/calendar';
import { transFormCalendarTask } from 'utils/DataTransform/Calendar/calendarList';
import { severityRatingEnums } from 'containers/Pages/Events/Layouts';
import isEmpty from 'lodash/isEmpty';

export const getTasksTransformed = createSelector(
  calendarSelectors.getTasks,
  ({ list }) => {
    if (isEmpty(list)) return [];
    return transFormCalendarTask(list, severityRatingEnums);
  },
);
export const getPatrolTransformed = createSelector(
  calendarSelectors.getPatrolEvents,
  ({ list }) => {
    if (isEmpty(list)) return [];
    return transFormCalendarTask(list, severityRatingEnums);
  },
);
export const getTransportEventsTransformed = createSelector(
  calendarSelectors.getTransportEvents,
  ({ list }) => {
    if (isEmpty(list)) return [];
    return transFormCalendarTask(list, severityRatingEnums);
  },
);
